import { Directive } from '@angular/core';

// Chrome scrollt beim Fokus nur Elemente heran, die ganz verdeckt sind. Ein
// angeschnittener Spaltenkopf oder eine angeschnittene Zeilenaktion bliebe beim
// Tabben halb ausserhalb der waagerecht scrollenden Liste.
@Directive({
  selector: '[appListFocusScroll]',
  host: {
    '(focusin)': 'reveal($event)',
  },
})
export class ListFocusScrollDirective {
  reveal(event: FocusEvent): void {
    if (event.target instanceof HTMLElement) {
      event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }
}
